var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("ckeditor", {
    attrs: {
      editor: _vm.editor,
      config: _vm.editorConfig,
    },
    on: {
      ready: _vm.prefill,
      input: _vm.onInput,
    },
    model: {
      value: _vm.currentText,
      callback: function callback($$v) {
        _vm.currentText = $$v
      },
      expression: "currentText",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }